import Logo from '../../Logo'
import { PropsWithChildren } from 'react'
import { Col, Row, Stack } from 'react-bootstrap'
import { Link } from 'react-router-dom'

const LinkItem = ({ children, to }: PropsWithChildren<{ to: string }>) => {
  return (
    <Link to={to} className="text-700 fw-semi-bold fs-9 mb-1">
      {children}
    </Link>
  )
}
// react router is not remountig this component or the terms component causing the scroll position to be at the botto when redirected to the terms and privacy page

const EcommerceFooter = () => {
  return (
    <section className="bg-100 dark__bg-1100 py-9">
      <div className="container-small">
        <Row className="justify-content-between gy-4">
          <Col xs={12} lg={4}>
            <Logo />
            <p className="text-700 mb-1 fw-semi-bold lh-sm fs-9">
              Somos un equipo apasionado por ayudar a clientes y proveedores para que los grandes
              eventos sucedan.
            </p>
          </Col>
          <Col xs={6} md="auto">
            <h5 className="fw-bolder mb-3">Sobre Fiestr</h5>
            <Stack>
              {/* <LinkItem to="#!">Careers</LinkItem>
              <LinkItem to="#!">Affiliate Program</LinkItem> */}
              <LinkItem to="/terms">Políticas de Privacidad</LinkItem>
              <LinkItem to="/terms">Términos y Condiciones</LinkItem>
            </Stack>
          </Col>
          {/* <Col xs={6} md="auto">
            <h5 className="fw-bolder mb-3">Redes Sociales</h5>
            <Stack>
              <LinkItem to="#!">Blogs</LinkItem>
              <Link to="#!" className="mb-1 fw-semi-bold fs-9">
                <FontAwesomeIcon icon={faFacebookSquare} className="text-primary me-2 fs-8" />
                <span className="text-800">Facebook</span>
              </Link>
              <Link to="#!" className="mb-1 fw-semi-bold fs-9">
                <FontAwesomeIcon icon={faTwitterSquare} className="text-info me-2 fs-8" />
                <span className="text-800">Twitter</span>
              </Link>
            </Stack>
          </Col> */}
          {/* <Col xs={6} md="auto">
            <h5 className="fw-bolder mb-3">Servicio al cliente</h5>
            <Stack>
              <LinkItem to="#!">Preguntas frecuentes</LinkItem>
              <LinkItem to="#!">24/7 Soporte</LinkItem>
              <LinkItem to="#!">Communidad Fiestr</LinkItem>
            </Stack>
          </Col>
          <Col xs={6} md="auto">
            <h5 className="fw-bolder mb-3">Escuela Fiestr</h5>
            <Stack>
              <LinkItem to="#!">¿Cómo publicar mis servicios?</LinkItem>
              <LinkItem to="#!">¿Cómo publicar mis servicios?</LinkItem>
              <LinkItem to="#!">¿Cómo publicar mis servicios?</LinkItem>
              <LinkItem to="#!">¿Cómo publicar mis servicios?</LinkItem>
            </Stack>
          </Col> */}
        </Row>
      </div>
    </section>
  )
}

export default EcommerceFooter
